import { ready, onShopifySectionLoad } from './utils/readyinit';
import { initSwiper, initSwiperMobile } from './components/swiper';
import initAccordion from './components/accordion';
import initAtcPopup from './components/atc-popup';
import initDrawer from './components/drawer';
import initLazyloadVideo from './utils/lazyloadVideo';
import initHeader from './sections/header/header';
import initCustomDropdowns from './components/custom-dropdowns';
import initMinicart from './components/minicart';
import initAtcForm from './components/atcForm';
import initAnnouncementCountdown from './components/announcement-countdown';
import initAnnouncementPhone from './components/announcement-phone';
import initTabbedMenu from './sections/tabbed-menu';
import initProductCardSwatches from './components/product-card-swatches';
import initQuickFilterDropdowns from './components/quick-filter-dropdowns';
import initMinicartDeliveryMessage from './lib/minicart-delivery';
import initSwymCartSync from './components/swym-cart-sync';
import initCartRecs from './components/cart-recs';

ready(() => {
  initSwiper();
  initSwiperMobile();
  initCustomDropdowns();
  initMinicart();
  initHeader();
  initAccordion();
  initLazyloadVideo();
  initAtcForm();
  initAtcPopup();
  initDrawer();
  initAnnouncementCountdown();
  initAnnouncementPhone();
  initTabbedMenu();
  initProductCardSwatches();
  initQuickFilterDropdowns();
  initMinicartDeliveryMessage();
  initSwymCartSync();
  initCartRecs();
});

onShopifySectionLoad(() => {
  initSwiper();
  initSwiperMobile();
  initCustomDropdowns();
  initHeader();
  initLazyloadVideo();
  initMinicart();
  initAtcForm();
  initDrawer();
  initAnnouncementCountdown();
  initAnnouncementPhone();
  initTabbedMenu();
  initProductCardSwatches();
});
